import { Box, Button, Tooltip, Typography } from "@mui/material";

import { INVESTMENT_ACTION_STATUSES } from "../constants";

function Action({ data, handleShowAction, fixed = false }) {
  const actionIsProcessing = data?.stateSecondId === INVESTMENT_ACTION_STATUSES.processing.id
  const actionIsClose = data?.stateSecondId === INVESTMENT_ACTION_STATUSES.close.id

  return (
    <Box
      display="flex"
      justifyContent={{ md: "center", xs: 'flex-end' }}
      alignItems="center"
    >
      <Tooltip title={data?.stateSecondTooltip} placement="top">
        {actionIsProcessing ? <Typography variant="h6" color="text.main">
          { data?.stateSecond}
        </Typography> : <Button
          disabled={actionIsProcessing}
          size="small"
          color={actionIsClose ? "info" : "error"}
          variant={actionIsProcessing ? "text" : "contained"}
          onClick={() => handleShowAction(data)}
        >
          { data?.stateSecond}
        </Button>}
      </Tooltip>
    </Box >
  );
}

export default Action;
